import { render, staticRenderFns } from "./gyra-filter.vue?vue&type=template&id=0b4c5604&scoped=true&"
import script from "./gyra-filter.vue?vue&type=script&lang=js&"
export * from "./gyra-filter.vue?vue&type=script&lang=js&"
import style0 from "./gyra-filter.vue?vue&type=style&index=0&id=0b4c5604&scoped=true&lang=scss&"
import style1 from "./gyra-filter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c5604",
  null
  
)

export default component.exports